import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-highlights.scss'

function remove_active_item(items) {
    let active_items = [...items].filter(item => item.classList.contains(`active`))
    if (active_items) {
        active_items.forEach(item => item.classList.remove(`active`))
    }
}

function set_active_item(items, target_group) {
    let active_items = [...items].filter(item => item.dataset.group === target_group)
    if (active_items) {
        active_items.forEach(item => item.classList.add(`active`))
    }
}

function set_sticky_top_height(section_id) {
    const header_height = document.getElementById(`shopify-section-theme-header`).getBoundingClientRect().bottom
    const section = document.querySelector(`section[data-section-id="${section_id}"]`)
    let nav = section.querySelector(`.medium-show.highlight-navigation`)
    nav.style[`top`] = `${header_height}px`
}

export default register(`section-highlights`, {
    onLoad() {

        const section = document.querySelector(`section[data-section-id="${this.id}"]`)

        const navigation_links = section.querySelectorAll(`.highlight-navigation li`)
        const highlight_groups = section.querySelectorAll(`.highlights-wrapper .highlight-group`)

        navigation_links.forEach(link => {
            link.addEventListener(
                `click`,
                () => {
                    if (!link.classList.contains(`active`)) {
                        remove_active_item(navigation_links)
                        remove_active_item(highlight_groups)

                        const target_group = link.dataset.group
                        set_active_item(navigation_links, target_group)
                        set_active_item(highlight_groups, target_group)
                    }
                })
        })

        set_sticky_top_height(this.id)
        window.addEventListener(`resize`, () => set_sticky_top_height(this.id))
    },
    onUnload() {

    },
})
